// Clube Braussie: preços, links de pagamento (Stripe, modo live) e textos compartilhados.
// Produto no Stripe: prod_VPt4qLTNsVQmBT. Todos os links têm 7 dias grátis e pedem o WhatsApp.
// Criados em 11/10/2026 pela CLI do Stripe; nada do que já existia foi alterado.

export type PlanoId = "mensal" | "anual" | "familia" | "fundadora";

export interface Plano {
  id: PlanoId;
  nome: string;
  preco: number;
  periodo: "mês" | "ano";
  descricao: string;
  priceId: string;
  paymentLinkId: string;
  url: string;
  destaque?: string;
}

export const PLANOS: Record<PlanoId, Plano> = {
  mensal: {
    id: "mensal",
    nome: "Mensal",
    preco: 29,
    periodo: "mês",
    descricao: "Cardápio toda quarta, lista por mercado, promoções, guias, comunidade e desafios.",
    priceId: "price_1UP3I7B2toyBbhi0mUyVe6hO",
    paymentLinkId: "plink_1UP3IBB2toyBbhi0FvBhSdGz",
    url: "https://buy.stripe.com/3cI5kCeuS1Kob2WdZHenS0d",
  },
  anual: {
    id: "anual",
    nome: "Anual",
    preco: 249,
    periodo: "ano",
    descricao: "Tudo do mensal, pagando 10 meses e levando 12.",
    priceId: "price_1UP3I8B2toyBbhi0P2t94o8F",
    paymentLinkId: "plink_1UP3IDB2toyBbhi0LJxBzitG",
    url: "https://buy.stripe.com/5kQaEW72q3Swef86xfenS0e",
    destaque: "2 meses grátis",
  },
  familia: {
    id: "familia",
    nome: "Família",
    preco: 39,
    periodo: "mês",
    descricao: "Até 4 perfis na mesma conta, cada um com a própria porção, lista somada.",
    priceId: "price_1UP3I9B2toyBbhi0Dxha4cRr",
    paymentLinkId: "plink_1UP3IEB2toyBbhi0nDaQBkIh",
    url: "https://buy.stripe.com/28E5kC86u4WA8UOcVDenS0f",
  },
  fundadora: {
    id: "fundadora",
    nome: "Turma Fundadora",
    preco: 19,
    periodo: "mês",
    descricao: "A$ 19 por mês para sempre, enquanto houver vaga. Só 50.",
    priceId: "price_1UP3IAB2toyBbhi0V1zWLOqj",
    paymentLinkId: "plink_1UP3IFB2toyBbhi0IUPo0t82",
    url: "https://buy.stripe.com/9B69ASfyWbkY1sm8FnenS0g",
    destaque: "50 vagas",
  },
};

export const TRIAL_DIAS = 7;

export const LOGOS_MERCADO: Record<string, string> = {
  Coles: "/images/mercados/coles.svg",
  Woolworths: "/images/mercados/woolworths-icon.svg",
  Aldi: "/images/mercados/aldi.svg",
};

/** Interruptor geral do clube. Decisão de 12/10/2026: fica fora do ar até a Clara apresentar o clube em vídeo
 *  e existir o que entregar (amostra de 3 dias, cardápio). Enquanto false:
 *  - /clube, /clube/bem-vinda e /vaga voltam para a home (no `vite dev` continuam abertas para revisão);
 *  - /clube sai da pré-renderização e do sitemap.
 *  Desde 14/10/2026 o quiz /diagnostico não depende mais do clube: virou a qualificação da Sessão Clareza.
 *  Para lançar: true aqui e as linhas do clube de volta no public/llms.txt (roteiro em docs/roadmap-lancamento-clube.md). */
export const CLUBE_NO_AR = false;

/** Modo de lançamento. Enquanto false, nenhum link do Stripe aparece: tudo leva para a lista VIP das fundadoras.
 *  Decisão de 11/10/2026: testar a demanda pela lista antes de abrir o checkout (o motor do cardápio ainda está em construção). */
export const VENDAS_ABERTAS = false;

/** Vagas de fundadora abrem em 10/11/2026 para a lista VIP. Trocar para true no dia (junto com VENDAS_ABERTAS). */
export const FUNDADORAS_ABERTAS = false;

export const DATA_LANCAMENTO = "10 de novembro";
/** Nome neutro das 50 primeiras vagas (serve para homens e mulheres). */
export const NOME_TURMA = "Turma Fundadora";
export const VAGAS_FUNDADORAS = 50;

/** Economia média estimada no mercado, por mês, comprando com o cardápio nas ofertas (18% das listas das últimas semanas). */
export const ECONOMIA_MES = 80;
export const ECONOMIA_SEMANA = 19;

/** Link de checkout com e-mail e nome preenchidos e a origem registrada. */
export const checkoutUrl = (
  plano: PlanoId,
  opts: { email?: string; nome?: string; origem?: string } = {},
) => {
  const url = new URL(PLANOS[plano].url);
  if (opts.email) url.searchParams.set("prefilled_email", opts.email);
  if (opts.origem) url.searchParams.set("client_reference_id", opts.origem.slice(0, 200));
  return url.toString();
};

export const BENEFICIOS = [
  { titulo: "Cardápio da semana, toda quarta", texto: "Montado nas ofertas do mercado onde você compra, com comida brasileira." },
  { titulo: "Porções no seu tamanho", texto: "Você preenche o perfil uma vez e as quantidades já vêm ajustadas para você." },
  { titulo: "Lista de compras com preço", texto: "Por corredor, com o total e o quanto você economizou com as ofertas." },
  { titulo: "Promoções da semana", texto: "As ofertas do Coles, Woolies e Aldi com a nota da Clara: o que vale e o que não vale." },
  { titulo: "14 guias práticos", texto: "Mercado, whey, molhos, marmitas, refeição livre, cruzeiro, acampamento e mais." },
  { titulo: "Comunidade no WhatsApp", texto: "Brasileiras na mesma situação, a compra da semana de cada uma e as dúvidas respondidas." },
  { titulo: "Live mensal com a Clara", texto: "Uma hora por mês para tirar dúvidas ao vivo, gravada para quem não puder." },
  { titulo: "Desafio de 21 dias, todo mês", texto: "Roteiro diário, check-in e ranking de constância. O primeiro é o Desafio de Verão." },
];

export const FAQ_CLUBE = [
  {
    question: "Eu não cozinho. O clube serve para mim?",
    answer:
      "Serve. O cardápio respeita o tempo que você disse ter: tem versão com marmita de 1 hora no dia de folga e receitas de 10 minutos para o dia a dia. Nada de prato de 40 minutos.",
  },
  {
    question: "Moro sozinha ou em shared house. Não vai sobrar comida?",
    answer:
      "As porções são para você, sem desperdício. A lista é calculada para a sua semana. A compra de uma pessoa tem ficado entre A$ 55 e 75 no Aldi.",
  },
  {
    question: "E o Medicare ou o plano de saúde?",
    answer:
      "Nutricionista não tem reembolso do Medicare. O clube custa menos que uma consulta e você vê o resultado na conta do mercado toda semana.",
  },
  {
    question: "Posso usar para a família toda?",
    answer:
      "Sim. O plano família tem até 4 perfis na mesma conta, cada pessoa com a própria porção na mesma refeição, e a lista soma tudo.",
  },
  {
    question: "Sou vegetariana. Tem cardápio para mim?",
    answer: "Tem. Toda semana sai a versão padrão e a vegetariana, as duas nas ofertas do seu mercado.",
  },
  {
    question: "O que é a Turma Fundadora?",
    answer:
      "São as 50 primeiras pessoas do clube. Pagam A$ 19 por mês para sempre, em vez dos A$ 29 do plano normal, enquanto continuarem assinando. As vagas abrem em 10 de novembro, primeiro para quem estiver na lista VIP.",
  },
  {
    question: "Entrar na lista é compra?",
    answer:
      "Não. Entrar na lista é de graça e sem compromisso. No dia 10 de novembro você recebe o link no WhatsApp, começa com 7 dias grátis e decide se fica.",
  },
  {
    question: "E se eu não gostar?",
    answer:
      "Você tem 7 dias grátis para ver o cardápio, a lista e a comunidade. Cancela em um clique, sem perguntas. No primeiro mês pago, devolução integral em até 30 dias.",
  },
];

export const WHATSAPP_CLARA = "https://wa.me/61423038977";
